import React from 'react'
import { Button } from '@material-ui/core'
import Screen from './Screen'
import { useRouter } from 'react-router5'
import { get as getFromDB } from '../db'
import invariant from 'invariant'
import RIP from '../images/noun_rip_1403200.svg'
import Pilot from '../images/noun_pilot_879259.svg'
import Trophy from '../images/noun_star_trophy_826027.svg'
import green from '@material-ui/core/colors/green';

const Success = ({ answerIds }) => {
  const router = useRouter()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%'
      }}
    >
      <div style={{ flexGrow: 1, textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
        <img src={Trophy} style={{ marginBottom: '-80px' }} />
        <p>Nice work! You have answered all {answerIds.length} questions correctly.</p>
      </div>

      <Button
        color="default"
        variant="outlined"
        onClick={() => router.navigate('home')}
      >
        Finish
      </Button>
    </div>
  )
}

const MoraleStatement = ({ corrects }) => {
  if (corrects === 0) {
    return <p>Oh no! That wasn't quite right.</p>
  }
  else if (corrects === 1) {
    return <p>Oh no! And you were just getting started.</p>
  }
  else {
    return <p>Oh no! While that wasn't correct, you still answered {corrects} questions correctly.</p>
  }
}

const Failed = ({ answerIds, incorrectAnswers }) => {
  const router = useRouter()
  const corrects = answerIds.length - incorrectAnswers.length;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <div style={{ flexGrow: 1, textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
        <img src={RIP} style={{ marginBottom: '-40px' }} />
        <MoraleStatement corrects={corrects} />
      </div>

      <Button
        color="default"
        onClick={() => router.navigate('home')}
      >
        Try again
      </Button>
    </div>
  )
}

export default function QuizSubmission({ quizId, questionIds, answerIds }) {
  const incorrectAnswers = answerIds.filter(id => {
    const answer = getFromDB(id)

    invariant(answer,
      `answer should be in database: ${id}`
    )

    return answer.correct !== true
  })

  return (
    <Screen>
      {incorrectAnswers.length ? (
        <Failed answerIds={answerIds} incorrectAnswers={incorrectAnswers} />
      ) : (
        <Success answerIds={answerIds} />
      )}
    </Screen>
  )
}